import {
	Empty,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
	EmptyTitle
} from '@/components/ui/empty'
import { AlertCircleIcon, InfoCircleIcon } from '@/components/ui/icons'
import { type TKey, useTranslation } from '@/translations/i18n'

interface TableStateProps {
	/** Override the default table copy (e.g. the events list uses its own). */
	title?: TKey
	description?: TKey
	className?: string
}

/** Error state shared by the marquee tables/lists (generic table copy default). */
export function TableError({ title, description, className }: TableStateProps) {
	const { t } = useTranslation()
	return (
		<Empty className={className}>
			<EmptyHeader>
				<EmptyMedia variant='icon'>
					<AlertCircleIcon className='fill-error-500' />
				</EmptyMedia>
				<EmptyTitle>
					{t(title ?? 'common:error_table_title')}
				</EmptyTitle>
				<EmptyDescription>
					{t(description ?? 'common:error_table_description')}
				</EmptyDescription>
			</EmptyHeader>
		</Empty>
	)
}

/** Empty state shared by the marquee tables/lists (generic table copy default). */
export function TableEmpty({ title, description, className }: TableStateProps) {
	const { t } = useTranslation()
	return (
		<Empty className={className}>
			<EmptyHeader>
				<EmptyMedia variant='icon'>
					<InfoCircleIcon />
				</EmptyMedia>
				<EmptyTitle>
					{t(title ?? 'common:empty_table_title')}
				</EmptyTitle>
				<EmptyDescription>
					{t(description ?? 'common:empty_table_description')}
				</EmptyDescription>
			</EmptyHeader>
		</Empty>
	)
}
